import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { PipesModule } from '@wilson/pipes';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { ShiftTimelineState } from '@wilson/shift-timeline/state';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { DateTimeFormat } from '@wilson/utils';

@Component({
  selector: 'wilson-timeline-shift-time-tag',
  templateUrl: './timeline-shift-time-tag.component.html',
  styleUrls: ['./timeline-shift-time-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NzTagModule, PipesModule],
})
export class TimelineShiftTimeTagComponent {
  readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly store = inject(Store);

  readonly SHADOW_SHIFT_ALLOWANCE_PIXEL =
    DragAndDropModeService.SHADOW_SHIFT_ALLOWANCE_PIXEL;
  @Input() resourcesColumnWidthPx!: number;

  DateTimeFormat = DateTimeFormat;
  LEFT_TAG_POSITION_MODIFIER = 52;
  RIGHT_TAG_POSITION_MODIFIER = 60;

  frameLength$ = this.store.select(ShiftTimelineState.frameLength);
}
